import { disPrices, freightPrices } from 'config/freightPrices';
import { CarModel, ExportType, VehicleType } from 'models/StockModel';

declare global {
    interface Array<T> {
        findLast(
            predicate: (value: T, index: number, obj: T[]) => unknown,
            thisArg?: any
        ): T
    }
}
const specialTypes = [
    VehicleType.SpecialEquipment,
    VehicleType.Excavator,
    VehicleType.Tractor,
    VehicleType.Roller,
    VehicleType.Crane,
    VehicleType.Forklift,
];

export const fillPricesOsaka = (car: CarModel) => {
    const result = {
        freight: 0,
        dis: 0,
    };

    if (!car.vehicleType)
        return result;

    if (car.vehicleType === VehicleType.Truck) {
        if (!car.length)
            return result;

        const freight = freightPrices.truck
            .findLast(item => item.length <= car.length!)!.price;

        const dis = car.exportType === ExportType.DisCar ?
            disPrices.truck.findLast(item => item.length <= car.length!)!.price : 0;

        return {freight, dis};
    }

    if (specialTypes.includes(car.vehicleType)) {
        if (!car.netWeight)
            return result;

        const freight = freightPrices.specialEquipment
            .findLast(item => item.weight <= car.netWeight!)!.price;

        const dis = car.exportType === ExportType.DisCar ?
            disPrices.specialEquipment : 0;

        return {freight, dis};
    }

    const freight = Object.entries(freightPrices.car)
        .find(([model]) => car.model.includes(model))?.[1] || 0;

    const dis = car.exportType === ExportType.DisCar ? disPrices.car : 0;

    return {freight, dis};
}